import { Box, Typography, alpha, useTheme } from '@mui/material';
import React from 'react';

export interface LiveStreamVideoFeedProps {
    displayName: string;
    setVideoRef: (el: HTMLVideoElement | null) => void;
    /** When true, this feed is shown as the main (primary) video. */
    isPrimary?: boolean;
    /** Called when the user clicks the feed to make it primary. */
    onSelect?: () => void;
}

const LiveStreamVideoFeed: React.FC<LiveStreamVideoFeedProps> = (props) => {
    const theme = useTheme();
    const overlayBg = alpha(theme.palette.common.black, 0.3);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                minHeight: 0,
                aspectRatio: '16/9',
                m: 0.1,
            }}
        >
            <Box
                onClick={props.onSelect}
                role={props.onSelect ? 'button' : undefined}
                sx={{
                    position: 'relative',
                    height: '100%',
                    aspectRatio: '16/9',
                    minHeight: 0,
                    borderRadius: 1,
                    overflow: 'hidden',
                    backgroundColor: '#000',
                    ...(props.onSelect && {
                        cursor: 'pointer',
                        '&:hover': { borderColor: '#81C784', opacity: 0.95 },
                    }),
                }}
            >
                <video
                    ref={props.setVideoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'fill',
                        backgroundColor: '#000',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 10,
                        insetInlineEnd: 10,
                        backgroundColor: overlayBg,
                        py: 0.5,
                        px: 1,
                        zIndex: 1,
                        borderRadius: 2,
                    }}
                >
                    <Typography sx={{ fontSize: '0.95rem', color: theme.palette.common.white, fontWeight: 600 }}>
                        {props.displayName}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default LiveStreamVideoFeed;
